import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#bell-off-clip0_2244_680)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M1.707.293A1 1 0 0 0 .293 1.707L4.5 6S4 7 4 8v6a2 2 0 0 1-2 2 1 1 0 1 0 0 2h14.586l5.707 5.707a1 1 0 0 0 1.414-1.414l-6-6-11.22-11.22zM14.586 16 6.168 7.582A6 6 0 0 0 6 8.999V14a4 4 0 0 1-.536 2zM9.05 3.77A6 6 0 0 1 18 9v4a1 1 0 1 0 2 0V9A8 8 0 0 0 8.069 2.03a1 1 0 1 0 .982 1.74m2.084 16.728a1 1 0 0 0-1.73 1.004 3 3 0 0 0 5.19 0 1 1 0 0 0-1.73-1.004 1 1 0 0 1-1.73 0",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "bell-off-clip0_2244_680" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }